import { render, staticRenderFns } from "./wordforms.vue?vue&type=template&id=f9d5d0ba&"
import script from "./wordforms.vue?vue&type=script&lang=js&"
export * from "./wordforms.vue?vue&type=script&lang=js&"
import style0 from "./wordforms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9d5d0ba')) {
      api.createRecord('f9d5d0ba', component.options)
    } else {
      api.reload('f9d5d0ba', component.options)
    }
    module.hot.accept("./wordforms.vue?vue&type=template&id=f9d5d0ba&", function () {
      api.rerender('f9d5d0ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/wordforms.vue"
export default component.exports